
import React from "react";
import "./Ourteam.css";
import members from "./Ourteam.json";



const Ourteam = () => {
 return (
<div className=" teamContainer">
<div className="row ">
{ members.map((member, index)=>{
    return(
  <div key={member.memberId} className="card teamCard col-12 col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-3 my-2 mx-auto py-2 bg-white text-dark border-0">
    <img className="image-fluid card-img-top" src={member.memberImage} alt=""/>
    <div className="card-body teamBody p-0">
      <h4 className="card-title teamTitle py-2">{member.memberName}</h4>
      <p className="card-text teamText w-100 my-2 ">{member.memberInfo}</p>
    </div>
    </div>

    )
  })}
</div>
</div>
 );
};

export default Ourteam;



// WEBPACK FOOTER //
// ./src/components/About/Ourteam/Ourteam.js